<template>
  <router-view />
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'App',
    created() {
        // This will record the previous page when the user goes to
        // a route in the legacy app
        window.addEventListener('beforeunload', () => {
            const previousPath = window.location.href.replace(window.origin, '');
            localStorage.setItem('previousPage', previousPath);
        });
    },
});
</script>
